import { isNotNull } from "./is-not-null";
export const isNotNullOrUndefined = (x) => isNotNull(x) && x !== undefined;
//# sourceMappingURL=is-not-null-or-undefined.js.map